/* APC CartTelemetry v4 - deliberately fail-open. No cart promise is awaited or replaced.
 *
 * 2026-08-02 metrics fixes:
 *  1. dataLayer pushes are no longer rate limited. emit() previously sent every
 *     apc_cart event through allowed(), which drops a repeat of the same key for
 *     5 minutes. That is correct for an alert beacon and wrong for analytics: real
 *     repeat adds of the same variant were silently never counted. allowed() now
 *     gates only notifyFailure().
 *  2. Duplicate apc_cart events. installObservers() re-runs at 0/100/500/1500/5000/
 *     15000ms so cart failures stay observable when a third party replaces
 *     window.fetch. The old guard only inspected the outermost wrapper
 *     (window.fetch.__apcCartTelemetry), so if any app wrapped fetch AFTER us the
 *     next re-install wrapped that and left two APC wrappers in the chain, emitting
 *     every cart event twice. This matters more now that (1) removed the accidental
 *     de-duplication.
 *  3. One /cart.js request per emission instead of one per event name. cart_open +
 *     view_cart still share a read, while checkout events emit synchronously before
 *     navigation so the browser cannot unload before GTM sees them.
 *  4. Standard GTM custom-event triggers receive apc_cart through event as well as
 *     the legacy name field, and XHR failures emit exactly once.
 *
 * 2026-08-04 fix: (2)'s original claim() keyed on the response promise, assuming
 * every wrapper layer sees the same promise object. Verified live that assumption
 * is false on this storefront: Elevar and the InstantJS/Meta pixel wrapper both
 * wrap window.fetch and return a new promise via .then() instead of passing the
 * original through. A fetch-call marker now lives only while wrappers synchronously
 * invoke the underlying fetch. It survives promise-transforming layers without
 * permanently suppressing a later real call that reuses the same RequestInit.
 */
(function (window, document) {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var build = document.documentElement.getAttribute('data-apc-theme-build') || 'unknown';
  var sessionKey = 'apc_cart_telemetry_session';
  var session = '';
  try { session = window.sessionStorage.getItem(sessionKey) || ''; if (!session) { session = 'c_' + Math.random().toString(36).slice(2, 12); window.sessionStorage.setItem(sessionKey, session); } } catch (_) { session = 'volatile'; }
  var seen = Object.create(null), sent = [], MAX_PER_MINUTE = 20;
  function now() { return Date.now(); }
  function allowed(key) { var t = now(); sent = sent.filter(function (x) { return t - x < 60000; }); if (sent.length >= MAX_PER_MINUTE || (seen[key] && t - seen[key] < 300000)) return false; seen[key] = t; sent.push(t); return true; }
  function bodyContext(init) {
    var out = {};
    try {
      var body = init && init.body;
      if (typeof body !== 'string') return out;
      var payload = JSON.parse(body);
      var items = Array.isArray(payload.items) ? payload.items : null;
      if (!items) {
        out.item_count = payload.quantity || undefined;
        out.variant_id = payload.id;
        return out;
      }

      var visibleItem = items.find(function (item) {
        return !(item && item.properties && item.properties._cf_ === 'addonProduct');
      }) || items[0];
      out.line_count = items.length;
      out.item_count = items.reduce(function (total, item) {
        var quantity = Number(item && item.quantity);
        return total + (Number.isFinite(quantity) ? quantity : 0);
      }, 0);
      out.variant_id = visibleItem && visibleItem.id;
    } catch (_) {}
    return out;
  }
  function cartOperation(input) { var url = typeof input === 'string' ? input : (input && input.url) || ''; var m = url.match(/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/); return m && m[1]; }

  /* Claim a fetch call only while wrapper layers synchronously delegate it. A
   * request object can be reused for later calls, so release it before the returned
   * promise settles; that preserves repeat-event measurement. */
  var claimed = (typeof window.WeakSet === 'function') ? new window.WeakSet() : null;
  function claim(input, init) {
    var key = init && typeof init === 'object'
      ? init
      : (input && typeof input === 'object' ? input : null);
    if (!claimed || !key) return { key: null, report: true };
    if (claimed.has(key)) return { key: null, report: false };
    claimed.add(key);
    return { key: key, report: true };
  }
  function releaseClaim(claimedCall) {
    if (claimed && claimedCall && claimedCall.key) claimed.delete(claimedCall.key);
  }

  function notifyFailure(event) {
    if (!event || event.outcome === 'success') return;
    // This is an alert signal, not a cart dependency. It contains no cart,
    // customer, or line-item-property data and any failure is intentionally ignored.
    try {
      var payload = JSON.stringify({ operation: event.operation, outcome: event.outcome, status: event.status, theme_build: event.theme_build, session: event.session, variant_id: event.variant_id, item_count: event.item_count });
      var url = 'https://inbox-push.atlaspetcompany.com/cart-telemetry';
      if (window.navigator && typeof window.navigator.sendBeacon === 'function' && typeof window.Blob === 'function') {
        window.navigator.sendBeacon(url, new window.Blob([payload], { type: 'text/plain' }));
      } else if (window.fetch) {
        window.fetch(url, { method: 'POST', mode: 'cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: payload }).catch(function () {});
      }
    } catch (_) {}
  }
  function emit(operation, outcome, status, context) {
    try {
      var event = { event: 'apc_cart', name: 'apc_cart', operation: operation, outcome: outcome, status: status || 0, theme_build: build, session: session, variant_id: context && context.variant_id, item_count: context && context.item_count, line_count: context && context.line_count };
      // Analytics needs true counts, so every event reaches dataLayer and Clarity.
      window.dataLayer = window.dataLayer || []; window.dataLayer.push(event);
      if (typeof window.clarity === 'function') { window.clarity('event', 'cart_' + operation + '_' + outcome); window.clarity('set', 'cart_operation', operation); window.clarity('set', 'cart_outcome', outcome); window.clarity('set', 'cart_status', String(event.status)); window.clarity('set', 'cart_build', build); window.clarity('set', 'cart_session', session); }
      // The outbound failure beacon stays rate limited: alert channel, not analytics.
      var key = [operation, outcome, status || 0, event.variant_id || ''].join(':');
      if (outcome !== 'success' && allowed(key)) notifyFailure(event);
    } catch (_) {}
  }
  function installFetch() { if (!window.fetch || window.fetch.__apcCartTelemetry) return; var nativeFetch = window.fetch; function observed(input, init) { var op = cartOperation(input); var context = bodyContext(init); var claimedCall = Boolean(op) ? claim(input, init) : { key: null, report: false }; var promise; try { promise = nativeFetch.apply(this, arguments); } catch (error) { if (claimedCall.report) emit(op, 'exception', 0, context); throw error; } finally { releaseClaim(claimedCall); } if (claimedCall.report && promise && typeof promise.then === 'function') { try { promise.then(function (response) { emit(op, response && response.ok ? 'success' : 'http_error', response && response.status, context); }, function () { emit(op, 'network_error', 0, context); }); } catch (_) {} } return promise; } observed.__apcCartTelemetry = true; window.fetch = observed; }
  function installXHR() { var proto = window.XMLHttpRequest && window.XMLHttpRequest.prototype; if (!proto || proto.__apcCartTelemetry) return; var open = proto.open, send = proto.send; proto.open = function (method, url) { this.__apcCartOperation = cartOperation(url); return open.apply(this, arguments); }; proto.send = function (body) { var xhr = this, op = xhr.__apcCartOperation; if (op) { var context = bodyContext({ body: body }); xhr.addEventListener('loadend', function () { var outcome = xhr.status === 0 ? 'network_error' : (xhr.status >= 200 && xhr.status < 300 ? 'success' : 'http_error'); emit(op, outcome, xhr.status, context); }, { once: true }); } return send.apply(this, arguments); }; proto.__apcCartTelemetry = true; }
  function installIntegrityListener() { if (installIntegrityListener.done) return; installIntegrityListener.done = true; document.addEventListener('apc:cart-integrity-failure', function (event) { var detail = event && event.detail || {}; emit(detail.operation || 'add', 'exception', 0, { variant_id: detail.reason || 'unknown' }); }); }
  // Third-party storefront scripts may replace window.fetch after this asset
  // loads. Re-attach during page settle so cart failures remain observable.
  function installObservers() { try { installFetch(); installXHR(); installIntegrityListener(); } catch (_) {} }
  installObservers();
  if (typeof window.setTimeout === 'function') {
    [0, 100, 500, 1500, 5000, 15000].forEach(function (delay) {
      window.setTimeout(installObservers, delay);
    });
  }

  function device() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop';
  }
  function sourceFor(target) {
    if (target && target.closest && target.closest('cart-element[data-cart-drawer]')) return 'drawer';
    if (window.location.pathname.indexOf('/cart') === 0) return 'cart_page';
    return 'product_page';
  }
  var lastKnownCart = null;
  function pushCanonical(names, source, cart) {
    if (typeof names === 'string') names = [names];
    var hasCart = cart && typeof cart.total_price !== 'undefined';
    window.dataLayer = window.dataLayer || [];
    names.forEach(function (name) {
      window.dataLayer.push({
        event: name,
        cart_value: hasCart ? Number(cart.total_price || 0) / 100 : null,
        cart_value_cents: hasCart ? Number(cart.total_price || 0) : null,
        item_count: hasCart ? Number(cart.item_count || 0) : null,
        device: device(),
        source: source,
        theme_build: build
      });
      if (typeof window.clarity === 'function') window.clarity('event', name);
    });
  }
  /* One cart read, N dataLayer events. Checkout events are pushed synchronously
   * before navigation, then the fetch only refreshes the local cart snapshot. */
  function emitCanonical(names, source, immediate) {
    if (immediate) pushCanonical(names, source, lastKnownCart);
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        if (cart) lastKnownCart = cart;
        if (!immediate) pushCanonical(names, source, cart);
        return cart;
      });
  }
  document.addEventListener('theme:cart:open', function () {
    emitCanonical(['cart_open', 'view_cart'], 'drawer');
  });

  var lastCheckout = 0;
  function trackCheckout(target) {
    var time = now();
    if (time - lastCheckout < 1000) return;
    lastCheckout = time;
    emitCanonical(['checkout_click', 'begin_checkout'], sourceFor(target), true);
  }

  document.addEventListener('click', function (event) {
    var checkout = event.target && event.target.closest && event.target.closest('[name="checkout"], [data-additional-checkout-button] button, [data-additional-checkout-button] a');
    if (checkout) trackCheckout(checkout);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.nodeName !== 'FORM' || !form.querySelector('[name="checkout"]')) return;
    trackCheckout(form);
  }, true);
  if (window.location.pathname.indexOf('/cart') === 0) {
    emitCanonical(['view_cart'], 'cart_page');
  }
})(window, document);
